class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.summaryToggle.setAttribute('role', 'button');

    // Abre o modal no momento da inicialização
    if (innerWidth > 1024) {
      this.open();
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  open() {
    this.detailsContainer.setAttribute('open', true);

    // Removendo a classe que desativa a rolagem do corpo
    document.body.classList.remove('overflow-hidden');

    // Removendo a chamada à função trapFocus se não for necessário manter o foco dentro do modal
    // trapFocus(
    //   this.detailsContainer.querySelector('[tabindex="-1"]'),
    //   this.detailsContainer.querySelector('input:not([type="hidden"])')
    // );
  }

}

customElements.define('details-modal', DetailsModal);
